export const timeAgo = (timestamp) => {
  if (!timestamp) return 'Just now';

  try {
    let date;
    // Handle different timestamp formats
    if (typeof timestamp === 'object' && timestamp.seconds) {
      // Firebase Timestamp or object with seconds
      date = new Date(timestamp.seconds * 1000);
    } else if (timestamp?.toDate) {
      // Firebase Timestamp with toDate method
      date = timestamp.toDate();
    } else if (timestamp instanceof Date) {
      // JavaScript Date object
      date = timestamp;
    } else if (typeof timestamp === 'number') {
      // Unix timestamp
      date = new Date(timestamp * 1000);
    } else if (typeof timestamp === 'string') {
      // ISO string or other date string
      date = new Date(timestamp);
    } else {
      return 'Just now';
    }

    const now = new Date();
    const secondsAgo = Math.floor((now - date) / 1000);

    if (isNaN(secondsAgo) || secondsAgo < 0) {
      return 'Just now';
    }

    const intervals = {
      year: 31536000,
      month: 2592000,
      week: 604800,
      day: 86400,
      hour: 3600,
      minute: 60,
      second: 1
    };

    for (const [unit, secondsInUnit] of Object.entries(intervals)) {
      const interval = Math.floor(secondsAgo / secondsInUnit);
      
      if (interval >= 1) {
        return interval === 1 
          ? `1 ${unit} ago`
          : `${interval} ${unit}s ago`;
      }
    }

    return 'Just now';
  } catch (error) {
    console.error('Error formatting timestamp:', error);
    return 'Just now';
  }
};
